import React from 'react';
import { Button } from '@/components/ui/button';
import { PasteGridPreview } from './PasteGridPreview';
import { getSourceLabel } from './test-table-editor/parseClipboardTable';
import type { ClipboardSource } from './test-table-editor/parseClipboardTable';

interface PastePreviewModalProps {
    parsedData: string[][];
    source: ClipboardSource;
    onConfirm: () => void;
    onCancel: () => void;
}

export const PastePreviewModal: React.FC<PastePreviewModalProps> = ({
    parsedData,
    source,
    onConfirm,
    onCancel,
}) => {
    if (parsedData.length === 0) return null;

    const sourceLabel = getSourceLabel(source);

    return (
        <div className="flex flex-col gap-4">
            <p className="text-sm text-muted-foreground">
                Dados copiados de <strong>{sourceLabel}</strong>.
            </p>

            <PasteGridPreview parsedData={parsedData} />

            <div className="flex justify-end gap-2 border-t pt-4">
                <Button variant="outline" onClick={onCancel} className="flex-1 sm:flex-initial">
                    Cancelar
                </Button>
                <Button onClick={onConfirm} className="flex-1 sm:flex-initial">
                    Colar
                </Button>
            </div>
        </div>
    );
};
